import { extractDataUriImagesFromHtml, extractOrderedSegmentsFromHtml } from './extractHtml';
import { extractDataUriImagesFromMarkdown, extractOrderedSegmentsFromMarkdown } from './extractMarkdown';
import type { ClipboardPasteSegment } from './types';

/**
 * Prefer HTML ordering when it yields real data-URI image nodes.
 * If HTML only mentions `data:image` as text, fall through to `text/plain`.
 */
export function extractOrderedClipboardSegments(clipboardData: DataTransfer): ClipboardPasteSegment[] {
  const html = clipboardData.getData('text/html');
  if (html && html.includes('data:image')) {
    const fromHtml = extractOrderedSegmentsFromHtml(html);
    if (fromHtml.some((segment) => segment.kind === 'image')) return fromHtml;
  }

  return extractOrderedSegmentsFromMarkdown(clipboardData.getData('text/plain') || '');
}

/** All unique data-URI image sources from HTML and plain text clipboard payloads. */
export function extractDataUriImagesFromClipboard(clipboardData: DataTransfer): string[] {
  const uris = new Set<string>();

  const html = clipboardData.getData('text/html');
  if (html) {
    extractDataUriImagesFromHtml(html).forEach((uri) => uris.add(uri));
  }

  const text = clipboardData.getData('text/plain');
  if (text) {
    extractDataUriImagesFromMarkdown(text).forEach((uri) => uris.add(uri));
  }

  return Array.from(uris);
}
